// Move company job between passive/archived states ***********************************************
// pathname: /v1/my-jobs/{slug}/state
// method:   PUT
// ************************************************************************************************
import {
  GenericV1ErrorsArray, useSwrMutationApi,
} from '@hooks/useSwrApi';
import { SwrToastsProps } from '@type/swr';

// Interface
// ********************************************
interface SwrChangeJobStateProps {
  slug: string,
  locale?: string,
  onSuccess?: () => void,
  onError?: (errors: GenericV1ErrorsArray) => void,
  toastsOptions?: SwrToastsProps,
}

/**
 * @description SWR mutation: PUT change company job state between passive/archived
 *
 * * **slug** - string. The job slug.
 * * **locale** - string. The locale to use for the request. Default: 'ro'.
 * * **successCallback** - function, optional. The callback to call on success.
 * * **errorCallback**: function, optional. The callback to call on fail.
 * * **toastsOptions**: SWR toasts options, optional.
 */
export const useSwrChangeJobState = (props: SwrChangeJobStateProps) => {
  // Props destructuring
  // ********************************************
  const {
    slug,
    locale = 'ro',
    onSuccess,
    onError,
    toastsOptions,
  } = props;

  // SWR mutation
  // ********************************************
  return useSwrMutationApi<ApiSchema<'MyJobCard'>, ApiSchema<'JobStateWrite'>>({
    url: `/v1/my-jobs/${slug}/state`,
    locale,
    fetcherConfig: {
      method: 'PUT',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess,
      onError,
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
      ...toastsOptions,
    },
  });
};
